import { render, staticRenderFns } from "./closureCheck.vue?vue&type=template&id=5546f533"
import script from "./closureCheck.vue?vue&type=script&lang=js"
export * from "./closureCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports